export enum RoutesFinalDataEnum {
  CONFIRMATION = 'confirmacion' as any,
  ULTIMATE = 'confirmacion-fim' as any
}
